export default __webpack_public_path__ + "static/media/login-road-background.b328330e.png";